export default "__VITE_ASSET__YGH3Dwmx__"